<template>
  <vs-row>
    
    <!-- {{section_type}} -->
    <!-- {{file_repository_id}} -->
    <!-- Browse Content -->
    <!-- Browse Content -->
    <!-- {{file_repository_id}} -->
    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
      <vs-card class="cstm-card w-full mb-4 collapse-cstm-card">
        <div class="collapse-item">
          <div
            class="flex justify-between header"
            slot="header"
            @click="isCollapseCard = !isCollapseCard"
            :class="{ activeCollapse: isCollapseCard }"
          >
            <h5>Files(Only JPEG and JPG files are allowed)</h5>
            <span class="material-icons">keyboard_arrow_down</span>
          </div>
          <div
            class="collapseContent"
            v-show="isCollapseCard"
            :class="{ active: isCollapseCard }"
          >
            <div class="cstm_vuefileagent_holder" :class="edit ? 'pt-100' : ''">
              <VueFileAgent
              @change="fileCrop($event)"
              multiple="false"
                ref="vueFileAgent"
                theme="grid"
                :deletable="true"
                :meta="true"
                :accept="imagevalidation"
                :maxSize="'10000MB'"
                :linkable="true"
                :helpText="imageHint"
                :errorText="{
                  type: 'Invalid file type. Only images Allowed',
                  size: 'Files should not exceed 10MB in size'
                }"
                class="chat-vue-file-agent"
                @select="filesSelected($event)"
                @beforedelete="onBeforeDelete($event)"
                @delete="fileDeleted($event)"
                v-model="fileRecords"
                @upload:error="uploadEvent('upload:error', $event)"
              ></VueFileAgent>
               <vs-tooltip class="inline-block align-bottom" color="primary"
                text="Import File From Your Existing System"
              >
                <vs-button
                  icon="folder_special"
                  class="mb-6 mx-1 icon_large_btn"
                  color="primary"
                  type="border"
                  @click="isBrowseContent = true"
                  ></vs-button
                >
              </vs-tooltip>
              <vs-tooltip class="inline-block align-bottom" color="primary"
                  text="Select files From Gdrive"
                >
                  <vs-button
                    class="mb-6 mx-1 icon_large_btn includeIcon includeIconOnly"
                    color="primary"
                    type="border"
                    @click="driveIconClicked()"
                    >
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" enable-background="new 0 0 32 32" height="32px" id="Layer_1" version="1.0" viewBox="0 0 32 32" width="32px" xml:space="preserve"><g><polyline fill="#537ABD" points="31.868,21 9.868,21 4.868,30 26.556,30  "/><polyline fill="#2EB672" points="10.962,2 -0.038,20 4.962,30 15.683,10.345  "/><polyline fill="#FED14B" points="20.962,2 10.962,2 21.712,21 31.962,21 20.962,2  "/></g></svg>
                  </vs-button>
                </vs-tooltip>
            </div>

            <div v-if="fileRecordsForUpload.length">
              <vs-divider />
               <vs-button
                :disabled="!fileRecordsForUpload.length"
                @click="uploadmodal=true"
              >
                Upload {{ fileRecordsForUpload.length }} files
              </vs-button>
            </div>
          </div>
        </div>
      </vs-card>
      <div class="vs-component con-vs-popup vs-popup-primary cstm-modal-popup"
      v-if="uploadmodal"
      :class="{show: uploadmodal}"
      >
              <div class="cstm-modal md:w-2/3 w-full">
                 <div class="header">
          <h3>Uploaded Template</h3>
          <button @click="uploadmodal = false" class="close-modal">&times;</button>
        </div>
        <form data-vv-scope="image">
                <div class="modal-content p-4" >

          <div  style="height:400px;">
            <cropper  @change="onChange" :src="imageDataUrl" :stencil-props="{handlers: {},movable: false,scalable: false}" :stencil-size="{width: 1123,height: 794}" image-restriction="stencil"/>
          </div>
          <vs-input type="text" data-vv-name="Image Name" v-validate="'required'" v-model="background_img_name" class="w-full mb-2" placeholder="Provide a name" />
           <span v-show="errors.has('image.Image Name')" class="text-danger">{{
                          errors.first(
                           'image.Image Name')
                        }}</span
                      >
          <vs-button
                @click="uploadFiles()"
                class="m-2"
              >
                Upload & Save
              </vs-button>
              </div>
        </form>

              </div>
      </div>
               <div v-if="isBrowseContent">
      <vs-popup fullscreen title="Browse Item" :active.sync="isBrowseContent">
        <import-browse-files-model
          v-if="isBrowseContent"
          :file_repository_id="file_repository_id"
          @getImportFile="getImportFile"
          :multipleSelect="multipleSelect"
        ></import-browse-files-model>
        <!-- <div slot="footer">jfjfjf</div> -->
      </vs-popup>
    </div>     
      
    </vs-col>
  </vs-row>
</template>

<script>
import ImportBrowseFilesModel from '@/components/common/ImportBrowseFilesModel.vue'
import {GoogleAuthorization} from '@/mixins/common/GoogleAuthorization.js'
import { getUploadedFilesId } from '@/api/assignment-question'
import { saveUploadFileApi} from '@/api/certificate'
import { UploadImage } from '@/api/common'
export default {
  name: 'FileTesting',
  components: { ImportBrowseFilesModel },
  mixins:[GoogleAuthorization],
  props: {
    file_repository_id: {
      required: false,
      type: Number,
      default: 0
    },
    edit: {
      required: false,
      type: Boolean
    },
    filesInfo: {
      required: false,
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      multipleSelect:false,
      isBrowseContent: false,
      width:'1123px',
      imageDataUrl:null,
      background_img_name:'',
      deletedIndex: null,
      uploadmodal:false,
      isCollapseCard: true,
      imageHint: 'Choose files or drag & drop here',
      imagevalidation: 'image/*',
      auto: true,
      fileRecords: [],
      uploadUrl: '',
      ///file/upload/${platform_customer_id}
      uploadHeaders: { 'X-Test-Header': 'vue-file-agent', 'Authorization': '' },
      fileRecordsForUpload: [],
      cropImage: null,
      importedFileData: [] // maintain an upload queue
    }
  },
  // config.headers['Authorization'] = `Bearer ${JSON.parse(localStorage.getItem('access_token'))}`

  async created () {
    const customer_id = await this.$store.getters.customerId
    const imageUploadUrl = process.env.VUE_APP_IMAGE_UPLOAD_URL
    this.uploadUrl = `${imageUploadUrl}${customer_id}`
    this.uploadHeaders.Authorization = `Bearer ${JSON.parse(
      localStorage.getItem('access_token')
    )}`
  },
  mounted () {

  },
  methods: {
    getImportFile ({ file_id, fileInfo }) {
      this.fileRecords =fileInfo
      this.SaveuploadedSFiles('system')
    },
    onChange ({ canvas }) {
      // const imageToUpload = canvas.toDataURL();
      canvas.toBlob(blob => {
        const fd = new FormData()
        fd.append('files[]', blob, 'image.jpg')
        fd.append('upload_path', 'ads')
        this.cropImage = fd
      })
    },
    async fileCrop (e) {
      console.log('crop')
      const file = e.target.files[0]
      const reader = new FileReader()
      reader.onload = (e) => {
        
        let data = null
        if (typeof e.target.result === 'object') {
          data = window.URL.createObjectURL(new Blob([e.target.result]))

        } else {
          data = e.target.result
        }
        this.imageDataUrl = data
       
      }
      reader.readAsArrayBuffer(file)
    },
    async SaveuploadedSFiles (type) {
      if (type === 'drive') {
        const payload = {
          file_id:this.filesInfo.file.files_id, 
          customer_id:this.$store.getters.customerId,
          name:this.background_img_name
        }
        const data = await saveUploadFileApi(payload)
        console.log(data)
        this.uploadmodal = false
        this.$emit('image', payload)

      } else if (type === 'system') {
        console.log(this.fileRecords)
        const payload = {
          file_id:this.fileRecords[0].files_id, 
          customer_id:this.$store.getters.customerId,
          name:this.fileRecords[0].file_name
        }
        const data = await saveUploadFileApi(payload)
        console.log(data)
        this.isBrowseContent = false
        this.$emit('image', payload)
      } else {
        const payload = {
          file_id:this.filesInfo.file.files_id, 
          customer_id:this.$store.getters.customerId,
          name:this.background_img_name
        }
        const data = await saveUploadFileApi(payload)
        console.log(data)
        this.uploadmodal = false
        this.$emit('image', payload)
      }
     
      
    },
    uploadEvent (eventName, data) {},
    async uploadFiles () {
      const result = await this.$validator.validateAll('image')
      if (result) {
        const payload = this.$store.state.LoginStorage.user_details.customer_id
        const data = await UploadImage(this.cropImage, payload)

        // this.$vs.loading({
        //   type: 'material',
        //   text: 'Please Wait We Are Uploading Files'
        // })

     
        const cdn = data.data.data.cdn

        const file_name = data.data.data.files[0].file_name
        const file_path = data.data.data.files[0].file_path

        const raw = JSON.stringify({
          file_repository_id: this.file_repository_id,
          files: [
            {
              file_name,
              file_path: `${cdn}${file_path}`
            }
          ]
        })

        const file_id_payload = raw

        this.getUploadFiles(file_id_payload)
        this.imageDataUrl = null
        

        this.fileRecords = []
        this.fileRecordsForUpload = []
      }
     
  
    },
    deleteUploadedFile () {
      if (
        this.section_type === 'courseHeader' ||
        this.section_type === 'CourseComponent'
      ) {
        this.$emit('deletedIndex', this.deletedIndex)
      }
    },
    filesSelected (fileRecordsNewlySelected) {
      const validFileRecords = fileRecordsNewlySelected.filter(
        fileRecord => !fileRecord.error
      )
      this.fileRecordsForUpload = this.fileRecordsForUpload.concat(
        validFileRecords
      )

    },
    onBeforeDelete (fileRecord) {
      const i = this.fileRecordsForUpload.indexOf(fileRecord)
      if (i !== -1) {
        // queued file, not yet uploaded. Just remove from the arrays
        this.fileRecordsForUpload.splice(i, 1)
        const k = this.fileRecords.indexOf(fileRecord)
        if (k !== -1) this.fileRecords.splice(k, 1)
      } else {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: 'Please Confirm',
          text: 'Are you sure you want to delete this file?',
          accept: this.acceptAlert,
          parameters: fileRecord
        })
      }
    },
    acceptAlert (fileRecord) {
      const index = this.fileRecords.indexOf(fileRecord)

      this.deletedIndex = index

      this.$refs.vueFileAgent.deleteFileRecord(fileRecord) // will trigger 'delete' event

      // this.$refs.vueFileAgent.deleteFileRecord(fileRecord) // will trigger 'delete' event
    },
    fileDeleted (fileRecord) {
      const i = this.fileRecordsForUpload.indexOf(fileRecord)
      if (i !== -1) {
        this.fileRecordsForUpload.splice(i, 1)
      } else {
        this.deleteUploadedFile(fileRecord)
      }
    },
    async getUploadFiles (file_id_payload, type = 'system') {
      const res = await getUploadedFilesId(file_id_payload)

      if (res.data.message === 'files.createFile') {
        /* const newRecord = this.generateFileForVueAgent(response[i].data.data.files[0])

               */
        const file = {
          file: res.data.data.files[0]
        }
        this.filesInfo = file
        const filesDriveInfo = res.data.data.files
        let filesDrive = []
        if (type === 'drive') {

          filesDrive = filesDriveInfo.map(ele => {
            return {
              name: ele.file_name,
              sizeText: this.bytesToSize(ele.size),
              size: ele.size,
              type: ele.file_type,
              url: ele.file_path,
              color: 'green',
              upload: {
                data: true,
                error: false
              }
            }
          })
          console.log(filesDriveInfo)
          this.fileRecords = filesDrive
          this.$vs.notify({
            title: 'Success',
            text: 'File Uploaded Successfully',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success',
            time: 1000
          })
          this.SaveuploadedSFiles('drive')
        } else {
          const file_id = res.data.data.files[0].files_id
          this.$vs.notify({
            title: 'Success',
            text: 'File Uploaded Successfully',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success',
            time: 1000
          })
          this.SaveuploadedSFiles('upload')
        }
       
        //

        // const fileIdObject = {
        //   question_index:this.question_detail_index,
        //   file_id
        // }

        this.$vs.loading.close()

        if (type === 'drive') {
          const fileIdObject = {file_id:filesDriveInfo.map(ele => ele.files_id)}
          console.log(fileIdObject)

          this.$emit('getFileId', fileIdObject)

        }

        //section type checking
      }
    },
    bytesToSize (bytes) {
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
      if (bytes === 0) return 'n/a'
      const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10)
      if (i === 0) return `${bytes} ${sizes[i]})`
      return `${(bytes / 1024 ** i).toFixed(1)} ${sizes[i]}`
    },
  
    generateFileForVueAgent (ele) {
      return {
        file_id: ele.file.id,
        name: ele.file.file_name,
        sizeText: this.bytesToSize(ele.file.size),
        size: ele.file.size,
        type: ele.file.file_type,
        url: ele.file.file_path,
        upload: {
          data: true,
          error: false
        }
      }
    }
  }
}
</script>
<style>

.childImportPopUp {
  z-index: 53001;
}
.pt-100 {
  padding-top: 100px;
}
</style>
